enum LedgerStatusReason {
  SKIPPED = 'Skipped',
  LOW_BALANCE = 'Low Balance',
  EXCEEDS_MAX = 'Max Savings',
  DISABLED = 'Disabled',
  ACCT_NOT_ACTIVE = 'Inactive',
  ACCT_DATA_UNAVAILABLE = 'Missing Data',
}

export default LedgerStatusReason;
